// lib
import { Box } from '@mui/material';
import React, { useState } from 'react';
// src
import { CardFoxtonsPrimeTeam } from '../../components/CardFoxtonsPrimeTeam';
import CarouselWrapper, { CarouselWrapperProps } from '../CarouselLayout';
// styles&utils
import ComponentWrapper from '../../components/ComponentWrapper';
import styles from './styles';

export interface LibFoxtonsPrimeTeamSectionProps {
  variant?: CarouselWrapperProps['variant'];
  richTextTitle?: string;
  foxtonsTeam: {
    isDetailOpen: boolean;
    name: string;
    subtitle: string;
    description?: string;
    memberImg: {
      image: string;
      alt: string;
    };
    email?: string;
    emailLink?: string;
    chat?: string;
    weChatLink?: string;
  }[];
  carouselButton?: {
    label: string;
    href: string;
    variant?: string;
    target?: string;
  };
}

function LibFoxtonsPrimeTeamSection({
  variant = 'aqua',
  richTextTitle = '',
  foxtonsTeam,
  carouselButton
}: LibFoxtonsPrimeTeamSectionProps) {
  const [expandedState, setExpandedState] = useState({});
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <CarouselWrapper
      variant={variant}
      richTitle={richTextTitle}
      type="expandableCards"
      noOfCardsLg={3}
      activeIndex={activeIndex}
      setActiveIndex={setActiveIndex}
      carouselButton={carouselButton}
    >
      {foxtonsTeam.map((item, idx) => (
        <ComponentWrapper
          otherProps={{
            key: JSON.stringify({ [idx]: expandedState[idx] || idx })
          }}
          key={idx}
        >
          <Box sx={styles.foxtonsTeam}>
            <CardFoxtonsPrimeTeam
              expandedStateOptions={{
                expandedState: Boolean(expandedState[idx]),
                setExpandedState: (val) =>
                  setExpandedState((prev) => ({ ...prev, [idx]: val }))
              }}
              isDetailOpen={item.isDetailOpen}
              name={item.name}
              subtitle={item.subtitle}
              description={item.description}
              email={item?.email || ''}
              emailLink={item?.emailLink || ''}
              chat={item?.chat || ''}
              weChatLink={item?.weChatLink || ''}
              memberImg={{
                image: item?.memberImg?.image || '',
                alt: item?.memberImg?.alt || ''
              }}
            />
          </Box>
        </ComponentWrapper>
      ))}
    </CarouselWrapper>
  );
}

export const FoxtonsPrimeTeamSection = React.memo(LibFoxtonsPrimeTeamSection);

export default FoxtonsPrimeTeamSection;
